import CurrencyFormatter from '@lmn/brg-ui-currency-formatter';
export var priceFormatterFactory = function priceFormatterFactory(locale, currency, minimumFractionDigits) {
  var formatter = new CurrencyFormatter(locale, currency, {
    minimumFractionDigits: minimumFractionDigits
  });
  return function (priceAsNumber) {
    return formatter.formatNumber(priceAsNumber);
  };
};
export var timerFormatterFactory = function timerFormatterFactory(formatConfig) {
  return function (minutesToFormat) {
    var hoursValue = Math.floor(minutesToFormat / 60);
    var minutesValue = minutesToFormat - hoursValue * 60;
    return "".concat(hoursValue < 10 && !formatConfig.hours ? "0".concat(hoursValue) : hoursValue).concat(formatConfig.hours).concat(formatConfig.divider).concat(minutesValue < 10 && !formatConfig.minutes ? "0".concat(minutesValue) : minutesValue).concat(formatConfig.minutes, " ");
  };
};